import React, { useState, useEffect, useCallback, useContext } from "react";
import "./FirstVendorDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col, Tab, Nav } from "react-bootstrap";
import Common_Button from "../../../Common-Component/Common_Button/Common_Button";
import {
  getProductSubVariant,
  getProductVariant,
} from "../../../../utils/apis/Product/Product";
import {
  faCartShopping,
  faHeart,
  faHeart as solidHeart,
} from "@fortawesome/free-solid-svg-icons";
import { getCartCheck } from "../../../../utils/apis/addToCart/addToCart";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Context } from "../../../../utils/context";

import {
  AddToCart,
  CartQuantity,
} from "../../../../utils/apis/addToCart/addToCart";
import { getAppSetup } from "../../../../utils/apis/common/Common";
import { useSearchParams } from "react-router-dom";
import {
  addWishlist,
  getWishlist,
} from "../../../../utils/apis/Wishlist/Wishlist";

const FirstVendorDetails = ({
  product,
  cartStatus,
  cartData,
  getProduct,
  setCartStatus,
  setSelected,
  setsubSelected,
  setCartData,
  handleProductClick,
  product_id,
  variant_id,
  m_variant_id,
}) => {
  const {
    variant,
    setVariant,
    setsubVariant,
    triggerCartUpdate,
    appSetup,
    setAppSetup,
    cartCount,
    signin,
    wishlistContext,
    wishlistData,
  } = useContext(Context);

  const navigate = useNavigate();

  const [number, setNumber] = useState(1);
  const [error, setErrors] = useState("");
  const [activeSubVariantId, setActiveSubVariantId] = useState(null);
  const [searchParams] = useSearchParams();

  const [showButtons, setShowButtons] = useState(false);
  const [showHeart, setShowHeart] = useState(false); // State for heart icon
  const [prdId, setPrdId] = useState("");
  const [variants, setVariants] = useState([]);
  const [subVariants, setSubVariants] = useState([]);
  const [isUpdatingQty, setIsUpdatingQty] = useState(false);

  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedVariantPrice, setSelectedVariantPrice] = useState(null);
  const [selectedSubVariant, setSelectedSubVariant] = useState(null);

  const handleNavigate = () => {
    // prefer the prop handler if provided (it handles navigate + reload/scroll)
    if (typeof handleProductClick === "function") {
      handleProductClick(product_id);
      return;
    }
    // fallback to direct navigation
    navigate(`/vendor-page/${product_id}`);
  };

  const handleHeartClick = async (data) => {
    if (signin) {
      const res = await addWishlist(data);
      if (res?.success) {
        await wishlistContext();
      }
    } else {
      await navigate("/login");
    }
  };

  useEffect(() => {
    const variantId = searchParams.get("variant_id");

    if (!variantId) {
      sessionStorage.removeItem("variantReloaded");
      return;
    }

    const lastReloadedVariant = sessionStorage.getItem("variantReloaded");

    if (lastReloadedVariant !== variantId) {
      sessionStorage.setItem("variantReloaded", variantId);
      window.location.reload();
    }
  }, [searchParams]);

  useEffect(() => {
    const variantId = searchParams.get("variant_id");

    if (variantId && variants?.length > 0) {
      const foundVariant = variants.find(
        (item) => item.id === Number(variantId)
      );

      if (foundVariant) {
        setSelectedVariant(foundVariant);
      }
    }
  }, [searchParams, variants]);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const addCart = async (data) => {
    if (selectedVariant === null) {
      setErrors("Select Size");
      return;
    }
    const res = await AddToCart(data);
    await getProduct();
    // const data = { product_id: product?.id, variant_id: selectedVariant?.id };
    const response = await getCartCheck(data);

    if (response?.success) {
      await setCartStatus(true);
      await setCartData(response?.cartItem);
      await triggerCartUpdate();
    } else {
      await setCartStatus(false);
      await setCartData(null);
      await triggerCartUpdate();
    }
    if (data.type === "buy") {
      navigate("/product-cart");
    }
  };

  const getCartQuantity = async (id, type, quantity) => {
    try {
      await CartQuantity(
        id,
        type,
        selectedVariant?.id ? selectedVariant?.id : selectedSubVariant?.id
      );

      triggerCartUpdate();

      if (quantity == 1 && type === "minus") {
        setCartStatus(false);
        triggerCartUpdate();
      }

      await getProduct();
    } catch (error) {
      console.error(error);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    reset,
    formState: { errors },
  } = useForm();

  const appSetupGet = async () => {
    const res = await getAppSetup();
    if (res?.success) {
      setAppSetup(res?.data);
    }
  };

  useEffect(() => {
    appSetupGet();
  }, []);

  useEffect(() => {
    setPrdId(product?.id);
    getProducts(prdId);
    getSubProducts(prdId);
  }, [product]);

  const getProducts = async () => {
    const res = await getProductVariant(product?.id);
    if (res?.success) {
      await setVariants(res?.data);

      if (!selectedVariant) {
        await setSelectedVariantPrice(res?.data[0]);
        await setSelectedVariant(res?.data[0]);
        await setSelected(res?.data[0]);
        await setVariant(res?.data[0]);
      }
    }
  };

  const getSubProducts = async () => {
    const res = await getProductSubVariant(product?.id);
    if (res?.success) {
      setSubVariants(res?.data);
      if (!selectedSubVariant) {
        setSelectedSubVariant(res?.data[0]);
        // setSelectedSubVariant(res?.data[0]?.product_multiple_variants?.[0]);
        setsubSelected(res?.data[0]);
        setsubVariant(res?.data);
        setActiveSubVariantId(res?.data[0]?.product_multiple_variants?.[0]?.id);
      }
    }
  };

  const handleVariantChange = async (variant) => {
    setSelectedVariant(variant);
    setSelectedVariantPrice(variant);
    setSelected(variant);
    setVariant(variant);
    setSelectedSubVariant(0);
    setErrors();

    // Remove query parameter from URL without navigation
    window.history.replaceState({}, document.title, window.location.pathname);
  };

  const handleSubVariantChange = async (subvariant) => {
    await setSelectedSubVariant(subvariant);
    await setsubSelected(subvariant);
    await setsubVariant(subvariant);
    await setActiveSubVariantId(subvariant.id);
  };

  const fetchData = async () => {
    try {
      const data = {
        product_id: product?.id,
        variant_id: selectedVariant?.id,
        m_variant_id: selectedSubVariant?.id,
      };

      const response = await getCartCheck(data);

      await triggerCartUpdate();

      if (response?.success) {
        await setCartStatus(true);
        await setCartData(response?.cartItem);
      } else {
        await setCartStatus(false);
        await setCartData(null);
      }
    } catch (error) {
      console.error(error);
      // Handle error
    }
  };
  useEffect(() => {
    fetchData();
  }, [selectedVariant, selectedSubVariant]);

  useEffect(() => {
    triggerCartUpdate();
  }, [cartStatus]);

  const [activeVariantId, setActiveVariantId] = useState(null);

  useEffect(() => {
    if (subVariants?.length > 0) {
      setActiveVariantId(subVariants[0]?.id);
    }
  }, [subVariants]);

  return (
    <section className="first-vendor-details">
      <div className="title-details mt-5">
        <h2>{product?.name}</h2>
        <div className="price_holder">
          <p className="mrp-class">
            ₹.{" "}
            {selectedVariantPrice?.mrp
              ? selectedVariantPrice?.mrp
              : selectedVariantPrice?.product_multiple_variants?.[0]?.mrp
              ? selectedVariantPrice?.product_multiple_variants?.[0]?.mrp
              : selectedVariantPrice?.mrp}
          </p>
          <p className="mrp-class return-mrp">
            ₹.
            {selectedVariantPrice?.cutting_price
              ? selectedVariantPrice?.cutting_price
              : selectedVariantPrice?.product_multiple_variants?.[0]
                  ?.cutting_price
              ? selectedVariantPrice?.product_multiple_variants?.[0]
                  ?.cutting_price
              : selectedVariantPrice?.cutting_price}
          </p>
        </div>
        <br></br>
      </div>

      <div className="variationdivvvvsize mb-3">
        <h6>Size</h6>

        <Nav className="horizontal-nav gap-2 mb-3">
          {variants.map((variant) => (
            <Nav.Item key={variant.id}>
              <Nav.Link
                eventKey={`v_name${variant.id}`}
                className={`${
                  selectedVariant?.id === variant.id ? "active" : ""
                } ${variant.unit <= 0 ? "disable_verient" : ""}`}
                disabled={variant.unit <= 0}
                onClick={() => handleVariantChange(variant)}>
                {variant?.v_name}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        <p style={{ color: "red" }}>{error}</p>

        <Tab.Container
          className="mt-4"
          id="left-tabs-example"
          defaultActiveKey="0">
          <Nav
            variant="pills"
            className="multivar-divv"
            activeKey={`variant_sub_name${activeVariantId}`}>
            {subVariants?.map((subvariant, index) => (
              <Nav.Item
                key={subvariant?.product_multiple_variants
                  ?.map((value) => value.id)
                  .join(",")}>
                <Nav.Link
                  eventKey={index}
                  className={
                    activeVariantId === subvariant?.id ? "active-link" : ""
                  }
                  onClick={() =>
                    handleSubVariantChange(
                      subvariant?.product_multiple_variants?.[0]
                    )
                  }>
                  {subvariant?.varient_name}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>

          <Tab.Content className="tabcontttttt mt-2">
            {subVariants?.map((subvariant, index) => (
              <Tab.Pane
                key={subvariant?.product_multiple_variants
                  ?.map((value) => value.id)
                  .join(",")}
                eventKey={index}>
                <div className="sub-variant-container">
                  {subvariant.product_multiple_variants.map(
                    (subInnervariant) => (
                      <p
                        key={subInnervariant.id}
                        className={`sub-variant-item ${
                          activeSubVariantId === subInnervariant.id
                            ? "active "
                            : ""
                        }`}
                        onClick={() => handleSubVariantChange(subInnervariant)}>
                        {subInnervariant.varient_sub_name}
                      </p>
                    )
                  )}
                </div>
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Tab.Container>
      </div>
      <div className="button-effect ">
        {cartStatus ? (
          <div className="blue-bg d-flex  me-3">
            <div className="circle-holder1">
              <button
                className="minus-btn me-md-5 me-0"
                type="button"
                onClick={() =>
                  getCartQuantity(cartData?.id, "minus", cartData?.quantity)
                }>
                <FontAwesomeIcon
                  className="minus-icon"
                  icon="fa-solid fa-minus"
                />
              </button>
            </div>
            <p className="number-text ">{cartData?.quantity}</p>
            <div className="circle-holder1">
              <button
                className="minus-btn"
                type="button"
                onClick={async () => {
                  if (isUpdatingQty) return;

                  if (cartData?.quantity >= selectedVariant?.unit) {
                    setErrors(`Only ${selectedVariant?.unit} in stock`);
                    return;
                  }

                  setIsUpdatingQty(true);

                  await getCartQuantity(
                    cartData?.id,
                    "add",
                    cartData?.quantity
                  );

                  setIsUpdatingQty(false);
                }}>
                <FontAwesomeIcon icon="plus" />
              </button>
            </div>
          </div>
        ) : (
          <div className="d-flex">
            {selectedVariant?.unit <= 0 ? (
              ""
            ) : (
              <Common_Button
                onClick={() =>
                  addCart({
                    product_id: product?.id,
                    variant_id: selectedVariant?.id,
                    type: "add",
                  })
                }
                className="add-to-cart-btn me-3"
                icon={faCartShopping}
                text="Add to Cart"
              />
            )}

            {signin && selectedVariant?.unit > 0 && (
              <Common_Button
                className="add-to-cart-btn"
                text=" Buy Now"
                icon="fa-solid fa-cart-shopping"
                onClick={() =>
                  addCart({
                    product_id: product?.id,
                    variant_id: selectedVariant?.id,
                    type: "buy",
                  })
                }
              />
            )}
          </div>
        )}

        <Common_Button
          onClick={async () =>
            await handleHeartClick({
              product_id: product?.id,
              variant_id: selectedVariant?.id,
              m_variant_id: m_variant_id,
            })
          }
          className={
            wishlistData?.some((item) => item.product_id == product?.id)
              ? "add-to-cart-btn ms-3 me-3"
              : "add-to-cart-btn ms-3 me-3"
          }
          icon={faHeart}
          text={
            wishlistData?.some((item) => item.product_id == product?.id)
              ? "Remove From Wishlist"
              : "Add to Wishlist"
          }
        />

        <Link to={"/product-cart"}>
          <Common_Button
            className="add-to-cart-btn  ms-3 me-3"
            icon={faCartShopping}
            text="Go to Cart"
          />
        </Link>
      </div>

      {/* After Onlclick */}
      <div className="description-class mt-4 mb-4">
        <h2 className="description-class-title">Description</h2>
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Nav variant="pills" className="flex-row">
            {product?.product_detail?.about && (
              <Nav.Item>
                <Nav.Link eventKey="first">About the Product</Nav.Link>
              </Nav.Item>
            )}

            {product?.product_detail?.benefits && (
              <Nav.Item>
                <Nav.Link eventKey="third">Size Chart</Nav.Link>
              </Nav.Item>
            )}
          </Nav>
          <Tab.Content className="mt-3">
            <Tab.Pane eventKey="first">
              <p className="text-holder-vendor-page">
                {htmlToReactParser.parse(product?.product_detail?.about)}
              </p>
            </Tab.Pane>
            <Tab.Pane eventKey="third">
              <p className="text-holder-vendor-page">
                {htmlToReactParser.parse(product?.product_detail?.benefits)}
              </p>
            </Tab.Pane>

            <Tab.Pane eventKey="four">
              {product?.product_detail?.brand?.name && (
                <Row>
                  <Col xl={3}>
                    <p className="brod-title">Brand:</p>
                  </Col>
                  <Col xl={9}>
                    <p className="brod-subtitle">
                      {product?.product_detail?.brand?.name}
                    </p>
                  </Col>
                </Row>
              )}

              <Row></Row>
              <Row>
                <Col xl={3}>
                  <p className="brod-title">Sold by:</p>
                </Col>
                <Col xl={9}>
                  <p className="brod-subtitle">{product?.user?.first_name}</p>
                </Col>
              </Row>
              <div className="orange-bg-details">
                <Row>
                  <Col xl={6}>
                    <p className="brod-title-2">Seller Email:</p>
                  </Col>
                  <Col xl={6}>
                    <p className="brod-subtitle-2">{product?.user?.email}</p>
                  </Col>
                </Row>
                <Row>
                  <Col xl={6}>
                    <p className="brod-title-2">Dhaga Customer Care Phone: </p>
                  </Col>
                  <Col xl={6}>
                    <p className="brod-subtitle-2">
                      +91 {product?.user?.contact_no}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col xl={6}>
                    <p className="brod-title-2">Country of Origin: </p>
                  </Col>
                  <Col xl={6}>
                    <p className="brod-subtitle-2">India</p>
                  </Col>
                </Row>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default FirstVendorDetails;
